import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-condition-german',
  templateUrl: './terms-and-condition-german.component.html',
  styleUrls: ['./terms-and-condition-german.component.scss']
})
export class TermsAndConditionGermanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
